import axios from 'axios'
import { getConfig, attach } from 'retry-axios'
import config from '../../config/local-config'
import apiConfig from '../../config/api-config'
import fetchCartApi from './fetchCartAPI'
import dateFormat from './dateFormat'
import createFormData from './createFormData'
import getAccessToken from './getAccessToken'
import getProp from './getProp'
import getBufferETAFlag from './getBufferETAFlag'
// import getEndecaSrc from "./getEndecaSrc";

const version = 'v1.1'
const serviceName = 'Order'
const apiUrl = `${
  apiConfig.apiURL
}/proxy-order/${serviceName}/${version}/index`
const getOrderItems = (
  orderId,
  { selected, ...selectedVehicle },
  productId,
  quantity,
) => {
  let orderItem = {
    p_id: productId,
    qty: quantity,
    site: config.hydra.site,
    item_warranty_amount: '0',
    rtpi: 'true',
    http_referer: __BROWSER__ ? encodeURIComponent(window.location.href) : '',
    isbot: config.isBot || '',
  }

  // Converted selected vehicle object into below format

  orderItem = Object.entries(selectedVehicle).reduce(
    (formatedVehicle, [key, value]) => ({ ...formatedVehicle, [key]: value.toString().replace(/:/g, '') }),
    orderItem,
  )
  return orderId ? { ...orderItem } : orderItem
}

const getVendorOrderItems = (product, quantity) => ({
  p_id: product.productId || '',
  qty: quantity,
  site: config.hydra.site,
  item_warranty_amount: '0',
  item_warranty_code: '0',
  sku_customization: product.skuCust || '',
  item_description: product.desc || '',
  sku: product.sku || '',
  list_price: product.price || '',
  year: product.year || '',
  make: product.make || '',
  model: product.model || '',
  submodel: product.submodel || '',
  engine: product.engine || '',
  // eslint-disable-next-line no-undef
  http_referer: __BROWSER__
    ? encodeURIComponent(window.location.href)
    : 'https://carparts.com',
})

// order
const getOrder = () => ({
  order: {
    coupon_option: '',
    user_id: '',
    merchant_order_id: 'CP',
    domain_name: config.hydra.site,
    order_status: '500',
    order_date: dateFormat,
    server_name: 'upwa.carparts.com',
    // eslint-disable-next-line no-undef
    remote_address: (__BROWSER__ && window.__TRUE_CLIENT_IP__) || '',
    // forter_token: "",
    server_host: 'upwa.carparts.com',
  },
})

const saveIds = (order, tokenDB) => {
  fetchCartApi(order, tokenDB).then(({ data }) => {
    const ids = {
      orderId: data.results.order.orderId,
      shipmentId: data.results.shipment[0].shipmentId,
      paymentId: data.results.payment.payment.paymentId,
    }
    window.localStorage.setItem('cartIds', JSON.stringify(ids))
  })
}

const isUnAuthorized = err => {
  const status = getProp(err, ['response', 'data', 'results', 'error'], {})
  if (status.status_code === 401) return true
  if (
    status.status_code === 400
    && status.message
    && status.message.toLowerCase().includes('token')
  ) { return true }
  return false
}
const getAxiosInstance = () => {
  const axiosInstance = axios.create()
  axiosInstance.defaults.raxConfig = {
    httpMethodsToRetry: ['POST'],
    instance: axiosInstance,
    shouldRetry: err => {
      const hasUnAuthorized = isUnAuthorized(err)
      if (hasUnAuthorized) return false
      const cfg = getConfig(err)
      return cfg.currentRetryAttempt < apiConfig.retryCount
    },
  }
  attach(axiosInstance)
  return axiosInstance
}

const executeAXIOS = (
  bodyFormData,
  orderId,
  customerId,
  accessToken,
  refreshToken,
) => new Promise((resolve, reject) => {
  const axiosInstance = getAxiosInstance()
  axiosInstance
    .post(apiUrl, bodyFormData, {
      headers: {
        apikey: apiConfig.apiKey,
      },
    })
    .then(res => {
      try {
        let oID = orderId
        if (!oID && __BROWSER__) {
          const results = getProp(res, ['data', 'results'])
          oID = typeof results === 'string' ? results : results[0]
          const newOrderId = getProp(results, ['order', 'newOrderId'])
          if (newOrderId) {
            oID = newOrderId
          }
          if (!Number.isNaN(oID)) {
            saveIds(oID, {
              customer_id: customerId,
              access_token: accessToken,
            })
          }
        }
        resolve(res)
      } catch (e) {
        resolve(res)
      }
    })
    .catch(err => {
      reject(err)
    })
})

const getLoggedInDetails = (token, email, customerId) => (token
  ? {
    customer_mgr_username: email,
    mgr_customer_id: customerId,
  }
  : { mgr_customer_id: customerId })
const addProduct = (
  product,
  quantity,
  selectedVehicle = {},
  orderId,
  tokenDB = {},
  vendor = false,
  postalCode,
  cartId = null,

) => {
  const {
    customer_id: customerId,
    access_token: accessToken,
    token_number: token,
    refresh_token: refreshToken,
    email,
  } = tokenDB
  // Default Order item
  // eslint-disable-next-line no-negated-condition
  const orderItem = !vendor
    ? getOrderItems(orderId, selectedVehicle, product.id, quantity)
    : getVendorOrderItems(product, quantity)

  // Order details
  const order = getOrder(orderId)

  const payment = {
    payment: {
      payment_method: 'CreditCard',
      enableCCpreauth: '1',
    },
  }

  const shipment = {
    shipment: {
      shipping_method: 'UPSGND',
      delivery_country: 'US',
      delivery_postcode: postalCode,
    },
  }

  const loggedInDetails = getLoggedInDetails(token, email, customerId)
  const customer = {
    customer: {
      customer_country: 'US',
      ...loggedInDetails,
    },
  }
  const orderIdInstance = orderId ? { order_id: orderId } : {}
  const bufferETAFlag = getBufferETAFlag()
  // Creating payload to add selected product
  const body = {
    iat: dateFormat || '',
    ...orderIdInstance,
    opt: orderId ? 'insertItem' : 'insertOrder',
    domain: config.hydra.site,
    data: {
      order: {
        ...order,
        shippingexp: 1,
        buffereta: bufferETAFlag,
        ...cartId ? { cart_id: cartId } : {},
      },
      ...shipment,
      ...customer,
      ...payment,
      order_items: orderItem,
      access_token: accessToken || '',
      customer_id: customerId || '',
      refresh_token: refreshToken || '',
    },
  }

  // added data into fordata for post request
  const bodyFormData = createFormData(body)
  let statusSuccess = true
  return executeAXIOS(bodyFormData, orderId, customerId, accessToken, refreshToken)
    .catch(err => {
      const hasUnAuthorized = isUnAuthorized(err)
      if (hasUnAuthorized) {
        statusSuccess = false
        return getAccessToken(true)
      }
      throw err
    })
    .then(response => {
      if (statusSuccess) return response
      return addProduct(
        product,
        quantity,
        selectedVehicle,
        orderId,
        response,
        vendor,
        postalCode,
        cartId,
      )
    })
}

export default addProduct
